{
  "hero": {
    "title": "Entwerfen.Umsetzen.Liefern."
  },
  "cta-contact": "Haben Sie ein Projekt im Sinn? Kontaktieren Sie uns!",
  "hook": "Die Investition in Videoinhalte ist nicht nur ein Trend – es ist ein strategischer Schritt, um Ihr Unternehmen zu entwickeln und in dem heutigen wettbewerbsintensiven Markt die Nase vorn zu haben.",
  "industry": {
    "title": "Medienlösungen für Ihre Branche",
    "options": {
      "ecommerce": "E-Commerce Unternehmen",
      "restaurants": "Restaurants & Cafés",
      "retail": "Einzelhandel",
      "salons": "Salons & Spas",
      "fitness": "Fitnesscenter & Studios",
      "realestate": "Immobilienmakler",
      "professional": "Professionelle Dienste",
      "homeservices": "HaushaltsDienste"
    }
  },
  "benefits": {
    "title": "10 Gründe warum Video-Content gut für Ihr Unternehmen ist:",
    "items": {
      "1": {
        "title": "1. Steigern Sie das Engagement:",
        "text": "Videos fesseln die Aufmerksamkeit schneller als jedes andere Medium und erhöhen das Engagement auf Ihrer Website und Social-Media-Plattformen."
      },
      "2": {
        "title": "2. Erzählen Sie Ihre Geschichte:",
        "text": "Präsentieren Sie die einzigartige Identität, Werte und Produkte Ihrer Marke auf eine überzeugende, visuelle Weise, die Ihr Publikum anspricht."
      },
      "3": {
        "title": "3. Steigern Sie die Konversionen:",
        "text": "Ein gut gestaltetes Video kann mehr Leads und Verkäufe generieren, indem es Ihre Angebote klar erklärt und Vertrauen bei potenziellen Kunden aufbaut."
      },
      "4": {
        "title": "4. Erweitern Sie Ihre Reichweite:",
        "text": "Video-Content ist sehr teilbar und hilft dabei, Ihre Botschaft einem breiteren Publikum über verschiedene Plattformen hinweg zu vermitteln."
      },
      "5": {
        "title": "5. Verbessern Sie SEO:",
        "text": "Videos verbessern das Ranking in Suchmaschinen, indem sie die auf Ihrer Website verbrachte Zeit erhöhen und mehr organischen Traffic generieren."
      },
      "6": {
        "title": "6. Vereinfachen Sie komplexe Ideen:",
        "text": "Nutzen Sie Animationen oder Erklärvideos, um komplizierte Konzepte für Ihre Kunden leicht verständlich zu machen."
      },
      "7": {
        "title": "7. Stärken Sie die Markenerinnerung:",
        "text": "Menschen erinnern sich eher an Ihre Marke, nachdem sie ein Video gesehen haben, im Vergleich zum reinen Lesen von Text."
      },
      "8": {
        "title": "8. Bauen Sie emotionale Verbindungen auf:",
        "text": "Video-Storytelling schafft tiefere Verbindungen zu Ihrem Publikum und fördert Loyalität und Vertrauen."
      },
      "9": {
        "title": "9. Passen Sie sich modernen Trends an:",
        "text": "Da Video das bevorzugte Content-Format für Verbraucher ist, bedeutet wettbewerbsfähig zu bleiben, dieses mächtige Medium zu nutzen."
      },
      "10": {
        "title": "10. Zeigen Sie Professionalität:",
        "text": "Hochwertige Videoproduktion spiegelt das Engagement Ihres Unternehmens für Exzellenz und Liebe zum Detail wider."
      }
    }
  },
  "services": {
    "title": "Dienste",
    "subtitle": "Per Projekt oder Abonnement",
    "tagline": "Wählen Sie die Flexibilität, die zu Ihren Bedürfnissen passt!",
    "description": "Mit unseren Projekt-Services erhalten Sie eine maßgeschneiderte Lösung für einmalige Videoproduktionen, perfekt für Präsentationen, Werbekampagnen oder besondere Events. Wenn Sie eine konstante, fortlaufende Unterstützung suchen, bietet unser monatliches Abonnement regelmäßige, hochwertige Videoinhalte, um Ihre Marke auf allen Plattformen frisch und ansprechend zu halten. Beide Optionen beinhalten professionelle Beratung, kreatives Storytelling und Optimierung für moderne Zielgruppen.",
    "cta": "Preise ansehen"
  },
  "gear": {
    "title": "Ich nutze professionelle Ausrüstung",
    "items": [
      "Panasonic GH7",
      "Olympus EM-III",
      "Elgato Prompter",
      "Peak Design",
      "Rode",
      "und mehr"
    ]
  },
  "software": {
    "title": "Ich nutze professionelle Software"
  },
  "comparison": {
    "title": "Der alte Weg",
    "titleKhromatik": "Der Khromatik-Weg",
    "items": [
      {
        "old": "3 verschiedene Freelancer anheuern, die nicht miteinander sprechen.",
        "khromatik": "Ein Partner, der Code, Design und Linse versteht."
      },
      {
        "old": "Schöne Website voller generischer Stock-Fotos.",
        "khromatik": "Maßgeschneiderter Content, speziell für Ihr Layout und Ihre Nutzer gedreht."
      },
      {
        "old": "Junior-Designer, die auf Ihr Budget lernen.",
        "khromatik": "20 Jahre Erfahrung, angewendet auf jedes Pixel und jeden Frame."
      }
    ]
  }
}
